exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".course-builder-content-container {\n  scroll-margin-top: 20px;\n}\n\n.course-builder-content {\n  margin-top: 25px;\n  flex: 1;\n  background-color: #FFF;\n  padding: 10px;\n  margin-bottom: 35px;\n}\n\n#course-builder {\n  margin: 0 auto;\n}\n\n#course-builder {\n  transform-origin: top center;\n  margin-top: 50px;\n  scroll-margin-top: 50px;\n  transition: all 0.25s;\n}\n\n#course-builder-container {\n  transform-origin: top center;\n  margin-top: 50px;\n  scroll-margin-top: 50px;\n  transition: all 0.25s;\n}", ""]);

// exports
